module.exports = __webpack_public_path__ + "static/media/egg.4fadc3b9.svg";